module.exports = __webpack_public_path__ + "img/logo-google-bing-yahoo.7fe22a62.png";